export enum LegalChangeDetailsTabs {
  major = 'major',
  minor = 'minor'
}
